<template>
    <div>
        <label v-if="label" class="block text-sm font-medium text-gray-700 mb-2">
            {{ label }}
            <span v-if="required" class="text-red-500">*</span>
        </label>
        <div class="border-2 border-gray-300 rounded-lg overflow-hidden">
            <Vue3SignatureEs
                ref="pad"
                :sigOption="option"
                :w="width"
                :h="height"
                :disabled="disabled"
                @begin="$emit('begin')"
                @end="$emit('end')"
            />
        </div>
        <div class="mt-3 flex items-center justify-between">
            <button
                @click="undo"
                type="button"
                class="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rent-risk-blue-400"
            >
                <svg class="-ml-0.5 mr-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"></path>
                </svg>
                Undo
            </button>
            <span class="text-sm text-gray-500">{{ helperText }}</span>
        </div>
        <p v-if="error" class="text-red-500 text-sm mt-2">{{ error }}</p>
    </div>
</template>

<script>
import Vue3SignatureEs from "vue3-signature";

export default {
    name: 'SignaturePad',
    components: { Vue3SignatureEs },
    emits: ['begin', 'end'],
    props: {
        label: { type: String, default: null },
        helperText: { type: String, default: 'Draw your signature above' },
        width: { type: String, default: '100%' },
        height: { type: String, default: '200px' },
        disabled: { type: Boolean, default: false },
        required: { type: Boolean, default: false },
        error: { type: String, default: null },
    },
    data() {
        return {
            option: {
                penColor: "rgb(0, 0, 0)",
                backgroundColor: "rgb(255,255,255)",
            },
        };
    },
    methods: {
        save() {
            return this.$refs.pad.save();
        },
        undo() {
            this.$refs.pad.undo();
        },
        clear() {
            this.$refs.pad.clear();
        },
        isEmpty() {
            return this.$refs.pad.isEmpty();
        },
        fromDataURL(dataUrl) {
            this.$refs.pad.fromDataURL(dataUrl);
        },
    },
};
</script>
